import React from 'react';

const BrandingFooter = () => {
  const logo = process.env.REACT_APP_LOGO_URL || (window.__BRANDING__ && window.__BRANDING__.logoUrl) || null;
  const footerText = process.env.REACT_APP_FOOTER_TEXT || (window.__BRANDING__ && window.__BRANDING__.footerText) || '';

  return (
    <footer className="branding-footer" role="contentinfo">
      {logo ? <img src={logo} alt="Site logo" onError={(e) => { e.currentTarget.style.display = 'none'; }} /> : null}
      <div>{footerText}</div>
    </footer>
  );
};

export default BrandingFooter;
